import React from 'react';
import styled from '@emotion/native';
import useExploreStore from '@/stores/useExploreStore';
import { PricingTier } from '@/shared/types/generated';
import PriceTierOption from './PriceTierOption';
import { Title } from './styledComponents';
import Spacer from '@/shared/components/Spacer';

interface PriceTierInfo {
  title: string;
  description: string;
  tier: PricingTier;
}

export const PRICE_TIERS: PriceTierInfo[] = [
  {
    title: 'FOUNDATION',
    description: 'Expert guidance at an accessible rate.',
    tier: PricingTier.Tier1,
  },
  {
    title: 'ELEVATED',
    description: 'Next-level styling for a refined look.',
    tier: PricingTier.Tier2,
  },
  {
    title: 'PREMIERE',
    description: 'High-caliber styling from seasoned experts.',
    tier: PricingTier.Tier3,
  },
  {
    title: 'ELITE',
    description: 'Exclusive styling from the best in the business.',
    tier: PricingTier.Tier4,
  },
];

const PriceFilters: React.FC = () => {
  const { filters, setFilters } = useExploreStore();

  const handleTierChange = (tier: PricingTier) => {
    const newTiers = filters.priceTier.includes(tier)
      ? filters.priceTier.filter((t) => t !== tier)
      : [...filters.priceTier, tier];

    setFilters({
      priceTier: newTiers,
    });
  };

  const handleShowAll = () => {
    setFilters({
      priceTier: [],
    });
  };

  return (
    <Container>
      <Title>Preferred Price Tier:</Title>
      {PRICE_TIERS.map(({ title, description, tier }) => (
        <PriceTierOption
          key={title}
          title={title}
          description={description}
          isSelected={filters.priceTier.includes(tier)}
          onPress={() => handleTierChange(tier)}
        />
      ))}
      <PriceTierOption
        title="SHOW ALL"
        isSelected={filters.priceTier.length === 0}
        onPress={handleShowAll}
      />
      <Spacer height={24} />
    </Container>
  );
};

const Container = styled.View({
  width: '100%',
});

export default PriceFilters;
